import { React, useRef } from "react";
import { Link } from "react-router-dom";
import { countries } from "../data";


const NavBar = (props) => {
  let data;
  const inputRef = useRef(null)
  return (
    <div>
      <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            Daily Bugle
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link" aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/business">
                  Business
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/entertainment">
                  Entertainment
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/general">
                  General
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/health">
                  Health
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/science">
                  Science
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/sports">
                  Sports
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/technology">
                  Technology
                </Link>
              </li>
            </ul>
            <div
              className="collapse navbar-collapse"
              id="navbarNavDarkDropdown"
            >
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to="#"
                    id="navbarDarkDropdownMenuLink"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Country
                  </Link>
                  <ul
                    className="dropdown-menu dropdown-menu-dark"
                    aria-labelledby="navbarDarkDropdownMenuLink"
                    style={{ height: "auto", maxHeight: "200px", overflowX: "hidden" }}
                  >
                   
                    {countries.map((country) => (<li className="nav-item" key={country.code}>
                      <Link
                        className="nav-link"
                        to="/"
                        onClick={() => {
                          props.updateCountryName(country.name);
                          props.updateCountry(country.code);
                        }}
                      >
                        {country.name}
                      </Link>
                    </li>))}
                  </ul>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-xs-3">
            <input
              type="text"
              className="form-control "
              placeholder="Type to Search..."
              value={props.value}
              ref={inputRef}
              onChange={(e) => {
                data = e.target.value;
              }}
            />
          </div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              inputRef.current.value = "";
              props.setSearch(data);
            }}
          >
            <Link
              style={{ color: "white", textDecoration: "none" }}
              to="/search"
            >
              Search
            </Link>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
